import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import fileTable from '@/components/border/fileTable';
import dial from '@/components/env-bigData/watch'; // 空气质量指数表盘图

import instrument from '@/components/env-bigData/instrument'; // 空气质量指数进度图

import barType from '@/components/env-bigData/barType'; // 空气质量天数表盘图

import plate from '@/components/env-bigData/plate'; // 空气质量天数双表盘图

import doublePlate from '@/components/env-bigData/doublePlate';
import waterAnalysisBar from '@/components/env-bigData/waterAnalysisBar';
import pieChart from '@/components/env-bigData/pieChart';
import { siteMapVocs } from '@/api/api';
export default {
  components: {
    pieChart: pieChart,
    fileTable: fileTable,
    dial: dial,
    instrument: instrument,
    barType: barType,
    plate: plate,
    doublePlate: doublePlate,
    waterAnalysisBar: waterAnalysisBar
  },
  data: function data() {
    return {
      fileState: true,
      showStates: false,
      siteDetail: {},
      selectType: 21,
      dateLists: [],
      standText: '',
      standState: false,
      standLabel: '',
      firstPollution: {},
      showDials: true,
      showInstrument: true,
      showPieChart: true,
      showBartype: true,
      showPlate: true,
      showdoublePlate: true,
      tenantId: 0,
      showMore: true
    };
  },
  mounted: function mounted() {// setInterval(this.scroll, 1000)
    // 获取租户id
    // this.getTenant()
  },
  methods: {
    getTenant: function getTenant() {
      this.tenantId = window.localStorage.getItem('tenant') ? window.localStorage.getItem('tenant') : 0;

      if (this.tenantId == 18) {
        this.showMore = false;
      }
    },
    close: function close() {
      this.$emit('close', false);
    },
    scroll: function scroll() {
      var _this = this;

      setTimeout(function () {
        if (_this.dateLists.length > 7) {
          _this.dateLists.push(_this.dateLists[0]); // 将数组的第一个元素添加到数组的


          _this.dateLists.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    ontoSite: function ontoSite() {
      var _this2 = this;

      sessionStorage.setItem('selectId', JSON.stringify(this.siteDetail)); // sessionStorage.setItem('selectIndex', 3)

      setTimeout(function () {
        // debugger
        _this2.$router.push({
          path: '/online/site',
          query: {
            siteId: _this2.siteDetail.id,
            siteName: _this2.siteDetail.name,
            st: _this2.siteDetail.st
          }
        });
      }, 1000);
    },
    changeState: function changeState(title, color, date, a, length) {
      var _this3 = this;

      this.showDials = false;
      this.$nextTick(function () {
        _this3.showDials = true;

        _this3.$nextTick(function () {
          _this3.$refs.dials.initBarChart(title, color, date, a, length);
        });
      });
    },
    changeInstrument: function changeInstrument(aqi, title, color) {
      var _this4 = this;

      this.showInstrument = false;
      this.$nextTick(function () {
        _this4.showInstrument = true;

        _this4.$nextTick(function () {
          _this4.$refs.instrument.initBarChart(aqi, title, color);
        });
      });
    },
    changeBartype: function changeBartype(arr, title) {
      var _this5 = this;

      this.showBartype = false;
      this.showPieChart = false;
      this.$nextTick(function () {
        _this5.showBartype = true;

        _this5.$nextTick(function () {
          console.log('bartype', arr, title);

          _this5.$refs.bartype.initBarChart(arr, title, 5000);
        });
      });
    },
    changeJxBarType: function changeJxBarType(id) {
      var _this6 = this;

      this.showBartype = false;
      this.showInstrument = false;
      this.showPieChart = false;
      this.$nextTick(function () {
        _this6.showPieChart = true;

        _this6.$nextTick(function () {
          siteMapVocs(id).then(function (res) {
            console.log('res', res);

            if (res.success && res.result) {
              var dataArr = [];
              res.result.forEach(function (item, index) {
                dataArr.push({
                  name: item.title,
                  value: item.upper
                });
              });

              _this6.$refs.pieChart.initBarChart(dataArr);
            } else {
              _this6.$refs.pieChart.initBarChart([]);
            }
          });
        });
      });
    },
    bartype2: function bartype2(arr1, arr2) {
      var _this7 = this;

      this.showStates = false;
      this.$nextTick(function () {
        _this7.showStates = true;

        _this7.$nextTick(function () {
          _this7.$refs.bartype2.initBarChart(arr1, arr2);
        });
      });
    },
    bartype3: function bartype3(arr1, arr2) {
      var _this8 = this;

      this.showStates = false;
      this.$nextTick(function () {
        _this8.showStates = true;

        _this8.$nextTick(function () {
          _this8.$refs.bartype3.initBarChart(arr1, arr2);
        });
      });
    },
    bartypes: function bartypes(arr1, arr2) {
      var _this9 = this;

      this.showStates = false;
      this.$nextTick(function () {
        _this9.showStates = true;

        _this9.$nextTick(function () {
          _this9.$refs.bartype4.initBarChart(arr1, arr2, 0.5);
        });
      });
    },
    changePlate: function changePlate(data) {
      var _this10 = this;

      console.log('data', data);
      this.showPlate = false;
      this.$nextTick(function () {
        _this10.showPlate = true;

        _this10.$nextTick(function () {
          _this10.$refs.plate.initBarChart(data);
        });
      });
    },
    changeDoubleplate: function changeDoubleplate(data, arr) {
      var _this11 = this;

      this.showdoublePlate = false;
      this.$nextTick(function () {
        _this11.showdoublePlate = true;

        _this11.$nextTick(function () {
          _this11.$refs.doublePlate.initBarChart(data, arr);
        });
      });
    }
  }
};